import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { _navBidder, _navCfo, _navDfo } from "./_nav";
import { NavLink } from "react-router-dom";
import Auth from "src/auth";
import MenuContext from "src/_components/ContextAPI";

const TheSidebar = () => {
  const { authenticated } = Auth();
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sidebarShow);
  const { menuList } = useContext(MenuContext);
  let navigation;
  if (authenticated.role === "CGMF") {
    navigation = menuList || [];
    if (
      navigation.length > 0 &&
      !navigation.some((item) => item.name === "Support Ticket")
    ) {
      navigation.push({
        _tag: "CSidebarNavItem",
        name: "Support Ticket",
        onClick: () =>
          window.open("http://202.131.108.246:4019/scp/login.php", "_blank"), // Opens in a new tab
        icon: "cil-puzzle",
      });
    }
  } else if (authenticated.role === "DFO") {
    navigation = _navDfo;
  } else if (authenticated.role === "CFO") {
    navigation = _navCfo;
  } else {
    navigation = _navBidder;
  }

  return (
    navigation.length > 0 && (
      <CSidebar
        className="DarkGeeenBg content"
        show={show}
        onShowChange={(val) => dispatch({ type: "set", sidebarShow: val })}
      >
        <CSidebarBrand className="d-md-down-none Green-Background">
          <NavLink to="/">
            <CIcon
              src={"avatars/logoImg.png"}
              title="CG Forest"
              className="c-sidebar-brand-full pt-3 pb-3"
              name="logo-negative"
              height={120}
            />
            <CIcon />
          </NavLink>
        </CSidebarBrand>

        <CSidebarNav className={"sidebar-wrapper"}>
          <CCreateElement
            items={navigation}
            components={{
              CSidebarNavDivider,
              CSidebarNavDropdown,
              CSidebarNavItem,
              CSidebarNavTitle,
            }}
          />
        </CSidebarNav>
        <CSidebarMinimizer className="c-d-md-down-none" />
      </CSidebar>
    )
  );
};
export default React.memo(TheSidebar);
